<template>
  <layout name="BaseLayout">
    <div>
      <v-data-table ref="dataTable" dense :headers="tableHeaders" :items="items" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" class="elevation-1" :loading="loading" :loading-text="loadingText" :footer-props="{
          itemsPerPageOptions: rowsPerPage,
          itemsPerPageAllText: allTextForPerPage,
          itemsPerPageText: itemsPerPageText,
        }" :options="options" :search="search" :custom-filter="customFilter" :no-results-text="filtersNoResultText">
        <!-- formatear el texto de la paginacion -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <!-- combo de edicion para una columna determinada -->
        <template v-if="userCanEdit" v-slot:item.nivel.descripcion="props">
          <v-edit-dialog :return-value.sync="props.item.nivel" @save="save(props.item)" @cancel="cancel"
            @open="open(props.item, props.item.nivel)" @close="close" large persistent :cancel-text="editDialogCancelText"
            :save-text="editDialogSaveText">
            <div>{{ props.item.nivel.descripcion }}</div>

            <template v-slot:input>
              <div class="mt-4 title">Actualizar nivel</div>
            </template>

            <template v-slot:input>
              <v-select :items="dialogNiveles(props.item.idioma)" label="Nivel" :value="props.item.nivel"
                item-text="descripcion" :no-data-text="selectNoDataText" return-object @change="saveTemp" />
            </template>
          </v-edit-dialog>
        </template>

        <!-- formatear columna de fecha de nacimiento -->
        <template v-slot:item.alumno.fechaNacimiento="{ item }">
          {{ item.alumno.fechaNacimiento | formatDateDDMMYYYY }}
        </template>

        <!-- formatear columna de pedido -->
        <template v-slot:item.prematricula.pagoTPVs="{ item }">
          {{ obtenerNumeroPedido(item) }}
        </template>

        <!-- cabecera (toolbar + filtros) antes del header de la tabla -->
        <template v-slot:top>
          <v-toolbar text color="white">
            <v-toolbar-title>Prematrículas</v-toolbar-title>

            <v-divider class="mx-4" inset vertical v-if="actions.allowExport" />

            <v-btn v-if="actions.allowRefresh" :loading="loading" :disabled="loading" @click="refreshItems" text
              color="primary">
              Actualizar
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>

            <template v-if="userCanEdit && isShowAsignarNivelesAlumnos()">
              <v-divider class="mx-4" inset vertical v-if="actions.allowExport" />

              <span>Asignar niveles a alumnos:</span>
              <v-btn @click="asignarNivelesAntiguosAlumnos" text color="primary"
                :loading="loadingAsignarNivelesAntiguosAlumnos" :disabled="loadingAsignarNivelesAntiguosAlumnos">Antiguos
              </v-btn>

              <v-btn @click="asignarNivelesNuevosAlumnos" text color="primary"
                :loading="loadingAsignarNivelesNuevosAlumnos" :disabled="loadingAsignarNivelesNuevosAlumnos">Nuevos
              </v-btn>
            </template>

            <v-spacer v-if="actions.allowExport"></v-spacer>

            <v-btn v-if="actions.allowExport && matriculas.length > 0" @click="exportMatriculasItems" text dark
              color="primary">exportar matrículas
            </v-btn>

            <!-- .refName.$children[0].filteredItems -->
            <v-btn v-if="items.length > 0" @click="exportItems" text dark color="primary">exportar prematriculas
            </v-btn>
          </v-toolbar>

          <!-- Filtros -->
          <v-container fluid>
            <v-row class="pl-3 pr-3 pt-1">
              <!-- Filtrar Buscador -->
              <v-col class="pt-0 pb-0" cols="3">
                <v-text-field class="pt-0 pb-0" v-model="search" prepend-icon="mdi-magnify" type="text" label="Buscar"
                  hide-details clearable />
              </v-col>

              <!-- Filtrar en localizacion -->
              <v-col class="pt-0 pb-0" cols="3" v-if="userRoles !== undefined &&
                locationFilterAllowedRoles.includes(userRoles[0])
                ">
                <v-select class="pt-0 pb-0" :items="localizaciones" item-text="nombre" item-value="nombre"
                  label="Localización" v-model="searchLocalizacion" clearable @change="cargarIdiomas"
                  :no-data-text="selectNoDataText" />
              </v-col>

              <!-- Filtrar en idioma -->
              <v-col class="pt-0 pb-0" cols="3">
                <v-select class="pt-0 pb-0" :items="idiomas" item-text="nombre" item-value="nombre" label="Idioma"
                  v-model="searchIdioma" clearable @change="cargarNiveles" :no-data-text="selectNoDataText"
                  :disabled="!searchLocalizacion" />
              </v-col>

              <!-- Filtrar en nivel -->
              <v-col class="pt-0 pb-0" cols="3">
                <v-select class="pt-0 pb-0" :items="niveles" label="Nivel" v-model="searchNivel" clearable
                  item-text="descripcion" item-value="descripcion" :no-data-text="selectNoDataText"
                  :disabled="!searchIdioma" />
              </v-col>
            </v-row>

            <!-- Boton borrado de filtros-->
            <v-row v-if="search || searchLocalizacion || searchIdioma || searchNivel" class="pa-0">
              <v-col cols="12" justify="center" align="center">
                <v-btn text dark color="primary" @click="borrarFiltros">
                  Borrar Filtros
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <!-- columna de acciones -->
        <template v-if="actions.allowEditPrematricula" v-slot:item.actions="{ item }">
          <v-btn small color="primary" icon @click="editItem(item)">
            <v-icon small>mdi-cog</v-icon>
          </v-btn>

          <v-btn small color="primary" icon :loading="loadingActionMatricula && isCurrentMatriculaItemLoading(item)
            " :disabled="loadingActionMatricula && !isCurrentMatriculaItemLoading(item)
    " @click="matriculaItem(item)">
            <v-icon small>mdi-clipboard-text-multiple</v-icon>
          </v-btn>
        </template>

        <!-- Se muestra con resultado vacio -->
        <template v-slot:no-data>
          {{ filtersNoResultText }}
        </template>
      </v-data-table>

      <!-- Edicion fullscreen -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogPrematricula" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <!-- cabecera full screen -->
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="closeDialogPrematricula">
                  <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-toolbar-title>Configurar prematricula</v-toolbar-title>
              </v-toolbar>

              <!-- contenido fullscreen -->
              <v-tabs v-model="tab" background-color="transparent" color="primary" grow @change="changeTab">
                <v-tab v-for="(tabItem, index) in tabItems" :key="index">
                  {{ tabItem.title }}
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item v-for="(tabItem, index) in tabItems" :key="index">
                  <!-- formulario prematricula -->
                  <template v-if="tabItem.type == 'prematricula' && editedItem != null">
                    <component :key="editDialogComponentsKey" :is="tabItem.component"
                      v-bind="{ item: editedItem, userCanEdit, userCanEditLlodio }"
                      @submitPrematricula="updatePrematricula" />
                  </template>

                  <!-- formulario solicitante -->
                  <template v-if="tabItem.type == 'solicitante' && editedItem != null">
                    <component :key="editDialogComponentsKey" :is="tabItem.component"
                      v-bind="{ item: editedItem, userCanEdit, userCanEditLlodio }" @submitSolicitante="updateSolicitante"
                      @sendEmails="sendEmails" />
                  </template>

                  <!-- formulario alumno -->
                  <template v-if="tabItem.type == 'alumno' && editedItem != null">
                    <component :key="editDialogComponentsKey" :is="tabItem.component" v-bind="{
                      item: editedItem,
                      userCanEdit,
                      userCanEditLlodio,
                      prematriculaAlumnosIdiomas: prematriculaAlumnosIdiomas,
                      idiomas: allIdiomas,
                      niveles: allNiveles,
                    }" @submitAlumno="updateAlumno" @submitAlumnoIdiomas="updateAlumnoIdiomas" />
                  </template>

                  <!-- formulario añadir alumno -->
                  <template v-if="tabItem.type == 'alumno-nuevo' && editedItem != null">
                    <component :is="tabItem.component" v-bind="{
                      item: editedItem,
                      userCanEditLlodio,
                      prematriculaAlumnosIdiomas: prematriculaAlumnosIdiomas,
                      idiomas: allIdiomas,
                      niveles: allNiveles,
                    }" @submitAlumnoNuevo="addAlumno" />
                  </template>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!-- Matricula fullscreen -->
      <template>
        <v-row justify="center">
          <v-dialog v-model="dialogMatricula" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
              <!-- cabecera full screen -->
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="closeDialogMatricula">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Configurar matrícula</v-toolbar-title>
              </v-toolbar>

              <!-- contenido matricula fullscreen -->
              <template v-if="editedMatricula">
                <v-card tile outlined>
                  <v-container>
                    <v-form v-model="formMatriculaValid" @submit.prevent="onSubmitMatricula($event)">
                      <template v-if="editedMatricula.prematricula != null">
                        <h3>Solicitante</h3>
                        <v-divider class="mb-6"></v-divider>

                        <v-container>
                          <p>
                            {{ editedMatricula.prematricula.persona.nombre
                            }}<br />{{
  editedMatricula.prematricula.persona.dni
}}
                          </p>
                        </v-container>
                      </template>

                      <template v-if="editedMatricula.alumnos != null">
                        <h3>Alumnos/as</h3>
                        <v-divider class="mb-6"></v-divider>

                        <v-container>
                          <v-row v-for="(editedMatriculaAlumno,
                            index) in editedMatricula.alumnos" :key="index">
                            <v-col justify="top" cols="3">
                              {{ editedMatriculaAlumno.name }}
                              <br />
                              {{ editedMatriculaAlumno.dni }}
                            </v-col>

                            <template v-if="editedMatriculaAlumno.prematriculas">
                              <v-col cols="9">
                                <v-row v-for="(editedMatriculaAlumnoPrematricula,
                                  indexp) in editedMatriculaAlumno.prematriculas" :key="indexp">
                                  <v-col cols="12" class="pa-0">
                                    <v-row v-if="editedMatriculaAlumnoPrematricula.nivel
                                      ">
                                      <v-col cols="2">
                                        {{
                                          editedMatriculaAlumnoPrematricula
                                            .idioma.nombre
                                        }}
                                      </v-col>

                                      <v-col cols="2">
                                        {{
                                          editedMatriculaAlumnoPrematricula
                                            .nivel.descripcion
                                        }}
                                      </v-col>

                                      <v-col cols="6">
                                        <v-select class="pa-0 ma-0" :id="`${editedMatriculaAlumno.id}${editedMatriculaAlumnoPrematricula.nivel.id}`
                                            " :items="generarItemsGrupo(
      editedMatriculaAlumnoPrematricula
        .nivel.id
    )
      " v-model="editedMatriculaAlumnoPrematricula.grupo
    " item-text="text" item-value="value" no-data-text="No hay opciones disponibles" return-object clearable
                                          @change="changeGrupo()" @click:clear="clearGrupo()" />
                                      </v-col>

                                      <v-col v-if="editedMatriculaAlumnoPrematricula.grupo
                                        " cols="2" align="right">
                                        <template v-if="editedMatricula.gratuita == 'si'
                                          ">
                                          Gratuita
                                        </template>

                                        <template v-else>
                                          <template v-if="editedMatricula.paymentOption == 1
                                            ">
                                            {{
                                              editedMatriculaAlumnoPrematricula
                                                .grupo.value.precio
                                              | formatFloat
                                            }}
                                          </template>

                                          <template v-else>
                                            {{
                                              editedMatriculaAlumnoPrematricula
                                                .grupo.value.precioIncrementado
                                              | formatFloat
                                            }}
                                          </template>
                                        </template>
                                      </v-col>
                                    </v-row>

                                    <v-row v-else class="">
                                      <v-col cols="2">
                                        {{
                                          editedMatriculaAlumnoPrematricula
                                            .idioma.nombre
                                        }}
                                      </v-col>

                                      <v-col cols="10">
                                        Sin nivel asignado
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </template>
                          </v-row>

                          <v-row v-if="total > 0">
                            <v-col cols="3"></v-col>

                            <v-col cols="9">
                              <v-row>
                                <v-col class="pa-0" cols="12">
                                  <v-row>
                                    <v-col cols="10" align="right">
                                      TOTAL:
                                    </v-col>

                                    <v-col cols="2" align="right">
                                      {{ total | formatFloat }}
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-container>
                      </template>

                      <template v-if="isSelectedGroup || !this.isMatriculaNew">
                        <h3>¿Gratuita?</h3>
                        <v-divider class="mb-6"></v-divider>

                        <v-container>
                          <v-radio-group v-model="editedMatricula.gratuita" row :mandatory="false" :rules="gratuitaRules"
                            @change="changeGratuita">
                            <v-radio v-for="(gratuitaOption,
                              indexg) in editedMatricula.gratuitaOptions" :key="indexg"
                              :label="`${gratuitaOption.text}`" :value="`${gratuitaOption.value}`" />
                          </v-radio-group>
                        </v-container>

                        <template v-if="showMatriculaPaymentsOptions">
                          <h3>Forma de pago</h3>
                          <v-divider class="mb-6"></v-divider>

                          <v-container>
                            <v-radio-group v-model="editedMatricula.paymentOption" :mandatory="false"
                              :rules="paymentOptionRules" @change="changePaymentOption">
                              <v-radio v-for="(paymentOption,
                                indexpo) in editedMatricula.paymentOptions" :key="indexpo"
                                :label="`${paymentOption.text}`" :value="`${paymentOption.value}`" />
                            </v-radio-group>
                          </v-container>

                          <h3>Método de pago</h3>
                          <v-divider class="mb-6"></v-divider>

                          <v-container>
                            <v-radio-group v-model="editedMatricula.paymentMethod" :mandatory="false"
                              :rules="paymentMethodRules">
                              <v-radio v-for="(paymentMethod,
                                indexpm) in editedMatricula.paymentMethods" :key="indexpm"
                                :label="`${paymentMethod.text}`" :value="`${paymentMethod.value}`" :disabled="isPaymentFraccionado(paymentMethod.value)
                                  " />
                            </v-radio-group>

                            <template v-if="editedMatricula.paymentMethod == 2">
                              <v-row>
                                <v-col cols="2">
                                  <v-text-field v-model="editedMatricula.iban_entidad" label="Entidad" maxlength="4"
                                    :rules="ibanRules" />
                                </v-col>

                                <v-col cols="2">
                                  <v-text-field v-model="editedMatricula.iban_sucursal" label="Sucursal" maxlength="4"
                                    :rules="ibanRules" />
                                </v-col>

                                <v-col cols="1">
                                  <v-text-field v-model="editedMatricula.iban_dc" label="DC" maxlength="2"
                                    :rules="ibanRules" />
                                </v-col>

                                <v-col cols="6">
                                  <v-text-field v-model="editedMatricula.iban_cuenta" label="Número de cuenta"
                                    maxlength="10" :rules="ibanRules" />
                                </v-col>
                              </v-row>

                              <v-text-field v-model="ibanv" :rules="ibanvRules" readonly="readonly" />
                            </template>
                          </v-container>
                        </template>
                      </template>

                      <v-card-actions>
                        <v-btn type="submit" color="primary" :loading="loadingSubmitMatriculas" text :disabled="!formMatriculaValid ||
                          (!isSelectedGroup && this.isMatriculaNew)
                          ">
                          Guardar
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-container>
                </v-card>
              </template>
            </v-card>
          </v-dialog>
        </v-row>
      </template>

      <!-- popup de confirmación -->
      <confirm ref="confirmNiveles" />
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import { mapGetters, mapMutations } from "vuex";
import {
  getByCurso,
  getById,
  remove,
  asignarNivelesAlumnos,
  matricular,
} from "@/api/prematriculas.api";
import { updatePrematriculaNivel } from "@/api/prematriculasAlumnos.api";
import { getIdiomas } from "@/api/idiomas.api";
import { getAllNiveles } from "@/api/niveles.api";
import { getByCurso as getGrupos } from "@/api/grupos.api";
import {
  getCSVData as getMatriculas,
  getByPrematricula,
} from "@/api/matriculas.api";
import { getAll as getTiposPago } from "@/api/pagoTipo.api";
import { getAll as getMetodosPago } from "@/api/pagoMetodo.api";
import DateUtils from "@/libraries/DateUtils";
import PrematriculaForm from "@/components/prematricula/PrematriculaForm";
import SolicitanteForm from "@/components/prematricula/SolicitanteForm";
import AlumnoForm from "@/components/prematricula/AlumnoForm";
import AlumnoNuevoForm from "@/components/prematricula/AlumnoNuevoForm";
import _ from "lodash";
import Confirm from "@/components/Confirm";
import MatriculaUtils from "@/libraries/MatriculaUtils";
import validaCCC from "@/libraries/ValidatorIban";

export default {
  name: "Prematriculas",

  components: {
    Layout,
    PrematriculaForm,
    SolicitanteForm,
    AlumnoForm,
    AlumnoNuevoForm,
    Confirm,
  },

  data: () => ({
    nivelEditedIndex: -1,
    nivelEditedItem: null,
    nivelTemp: null,
    sortBy: "alumno.nombre",
    sortDesc: false,
    actions: {
      allowEditPrematricula: true,
      allowExport: true,
      allowRefresh: true,
    },
    items: [],
    matriculas: [],
    headers: [],
    idiomas: [],
    niveles: [],
    rowsPerPage: [25, 50, 75, 100, -1],
    options: {
      itemsPerPage: 25,
    },
    loading: false,
    refreshLoading: false,
    // valores de los filtros
    search: "",
    searchLocalizacion: "",
    searchIdioma: "",
    searchNivel: "",
    // textos varios
    filtersNoResultText: "No se han encontrado resultados",
    loadingText: "Cargando ...",
    selectNoDataText: "No hay valores",
    itemsPerPageText: "Filas por página:",
    allTextForPerPage: "Todas",
    editDialogCancelText: "Cancelar",
    editDialogSaveText: "Guardar",
    snackSuccessTextSendEmails: "Envío realizado correctamente",
    snackErrorTextSendEmails: "No ha sido posible realizar el reenvío",
    snackSuccessTextRemove: "Se ha borrado correctamente",
    snackErrorTextRemove: "No ha sido posible borrar la prematrícula",

    // dialog edicion y tabs
    dialogPrematricula: false,
    editedItem: null,
    prematriculaAlumnosIdiomas: null,
    editDialogComponentsKey: 0,
    tab: 0,
    tabItems: [],

    // dialog matricula
    dialogMatricula: false,
    editedMatricula: null,
    isMatriculaNew: true,
    loadingActionMatricula: false,
    loadingMatriculaActionRef: "",
    loadingSubmitMatriculas: false,
    formMatriculaValid: false,
    paymentOptionRules: [(v) => !!v || "Selecciona una forma de pago"],
    paymentMethodRules: [(v) => !!v || "Selecciona un método de pago"],
    gratuitaRules: [(v) => !!v || "Selecciona una opción"],
    ibanRules: [(v) => !!v || "El campo es obligatorio"],
    ibanvRules: [(v) => validaCCC(v) || "El número Iban no es correcto"],

    // acciones asignar niveles
    loadingAsignarNivelesNuevosAlumnos: false,
    loadingAsignarNivelesAntiguosAlumnos: false,

    // listados de roles para determinar uso de filtros
    locationFilterAllowedRoles: ["ROLE_SUPER_ADMIN"],
  }),

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
      localizaciones: "GET_LOCALIZACIONES",
    }),

    ...mapGetters("Auth", {
      userCanEdit: "userCanEdit",
    }),

    ...mapGetters("Auth", {
      userCanEditLlodio: "userCanEditLlodio"
    }),

    ...mapGetters("Auth", {
      userRoles: "authRoles",
    }),

    tableHeaders() {
      return this.headers;
    },

    formTitle() {
      return this.editedIndex === -1 ? "Nuevo item" : "Editar Item";
    },

    showActions() {
      return this.allowShowActions();
    },

    showMatriculaPaymentsOptions() {
      return this.togglePaymentsOptions();
    },

    isSelectedGroup() {
      let isSelected = false;
      // no se ha cargado la matricula a editar
      if (this.editedMatricula == null) {
        return isSelected;
      }

      // comprobar los grupos en todas las prematriculas de los alumnos
      this.editedMatricula.alumnos.forEach((alumno) => {
        alumno.prematriculas.forEach((prematricula) => {
          if (prematricula.grupo != null) {
            isSelected = true;
          }
        });
      });

      return isSelected;
    },

    total() {
      return this.calculateEditedMatriculaTotal();
    },

    ibanv() {
      if (this.editedMatricula == null) {
        return "";
      }

      return `${this.editedMatricula.iban_entidad}${this.editedMatricula.iban_sucursal}${this.editedMatricula.iban_dc}${this.editedMatricula.iban_cuenta}`;
    },
  },

  watch: {
    cursoActual() {
      this.items = [];
      this.initialize();
    },

    showMatriculaPaymentsOptions() {
      return this.togglePaymentsOptions();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    obtenerNumeroPedido(item) {
      return this.pagoTPVsToString(item);
    },

    pagoTPVsToString(item) {
      if (
        !_.isNil(item.prematricula.pagoTPVs) &&
        !_.isEmpty(item.prematricula.pagoTPVs)
      ) {
        let lastIndex = item.prematricula.pagoTPVs.length - 1;
        let pago = item.prematricula.pagoTPVs[lastIndex];
        return pago.codigoTransaccion;
      }

      return "";
    },

    ...mapMutations("Snack", {
      setSnack: "SET_SNACK_OPTIONS",
    }),

    /**
     * inicializa todos los valores necesarios del componente
     */
    async initialize() {
      this.loading = true;

      if (this.cursoActual) {
        /**
         * Config table headers
         */
        this.headers = [
          { text: "Prematricula", align: "start", value: "prematricula.id" },
          { text: "Pedido", align: "center", value: "prematricula.pagoTPVs" },
          {
            text: "Localización",
            align: "start",
            value: "prematricula.localizacion.nombre",
            filter: (value) => this.filtrarLocalizacion(value),
          },
          { text: "Nº alumno", align: "center", value: "alumno.codigo" },
          { text: "Apellidos, Nombre", align: "start", value: "alumno.nombre" },
          {
            text: "Fecha nacimiento",
            align: "center",
            value: "alumno.fechaNacimiento",
          },
          {
            text: "Idioma",
            align: "start",
            value: "idioma.nombre",
            filter: (value) => this.filtrarIdioma(value),
          },
          {
            text: "Nivel",
            align: "start",
            value: "nivel.descripcion",
            filter: (value) => this.filtrarNivel(value),
          },
        ];

        if (this.allowShowActions()) {
          this.headers.push({ text: "", value: "actions", sortable: false });
        }

        // tabs items
        this.tabItems = [
          {
            title: "Inf. Prematricula",
            type: "prematricula",
            component: "prematricula-form",
          },
          {
            title: "Inf. Solicitante",
            type: "solicitante",
            component: "solicitante-form",
          },
          { title: "Inf. Alumno", type: "alumno", component: "alumno-form" },
        ];

        // only admin tabs items
        if (this.userCanEdit || this.userCanEditLlodio) {
          this.tabItems.push({
            title: "+ Alumno",
            type: "alumno-nuevo",
            component: "alumno-nuevo-form",
          });
        }

        await getIdiomas().then(
          (response) => (this.allIdiomas = response.data)
        );
        await getAllNiveles().then(
          (response) => (this.allNiveles = response.data)
        );
        await getMatriculas(this.cursoActual.id).then(
          (response) => (this.matriculas = response.data)
        );
        await getByCurso(this.cursoActual.id).then((response) => {
          if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
            const allowedLocation = this.userRoles[0]
              .split("ROLE_SUPER_ADMIN_")[1]
              .toLowerCase();

            this.items = this.generateItems(
              response.data.filter(
                (el) => el.localizacion.nombre.toLowerCase() === allowedLocation
              )
            );

            this.searchLocalizacion =
              this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
              this.userRoles[0]
                .split("ROLE_SUPER_ADMIN_")[1]
                .substring(1)
                .toLowerCase();

            this.cargarIdiomas();

            return;
          }

          this.items = this.generateItems(response.data);
        });
      }

      this.loading = false;
    },

    async refreshItems() {
      this.loading = true;
      this.items = this.matriculas = [];
      await getMatriculas(this.cursoActual.id).then(
        (response) => (this.matriculas = response.data)
      );
      await getByCurso(this.cursoActual.id).then(
        (response) => (this.items = this.generateItems(response.data))
      );
      this.loading = false;
    },

    /**
     * valores para el combo de niveles para cada uno de los items del listado
     */
    dialogNiveles(idioma) {
      return this.filtrarNivelesPorIdioma(idioma);
    },

    /**
     * devuelve los niveles de un idioma
     */
    filtrarNivelesPorIdioma(idioma) {
      return this.allNiveles.filter((nivel) => nivel.idioma.id == idioma.id);
    },

    /**
     * parsear listado de prematriculas (1 item por alumno)
     */
    generateItems(prematriculas) {
      let items = [];

      prematriculas.forEach((prematricula) => {
        prematricula.alumnos.forEach((prematriculaAlumno) => {
          items.push(this.generateItem(prematricula, prematriculaAlumno));
        });
      });

      return items;
    },

    /**
     * Parsear un item de prematriculaAlumno a fila de tabla
     */
    generateItem(prematricula, prematriculaAlumno) {
      return {
        id: prematriculaAlumno.id, // id de la tabla prematriculasAlumnos
        tutor: {
          ...prematricula.persona,
        },
        alumno: {
          ...prematriculaAlumno.alumno,
        },
        idioma: {
          ...prematriculaAlumno.idioma,
        },
        nivel: {
          ...prematriculaAlumno.nivel,
        },
        curso: {
          ...prematricula.curso,
        },
        prematricula: {
          ...{
            id: prematricula.id,
            codigo: prematricula.codigo,
            entidad: prematricula.entidad,
            oficina: prematricula.oficina,
            cuenta: prematricula.cuenta,
            anulada: prematricula.anulada,
            domiciliacion: prematricula.domiciliacion,
            orden: prematricula.orden,
            gratuita: prematricula.gratuita,
            colegio: prematricula.colegio,
            empresa: prematricula.empresa,
            veracidad: prematricula.veracidad,
            privacidad: prematricula.privacidad,
            fase: prematricula.fase,
            formaConocer: {
              ...prematricula.formaConocer,
            },
            amigo: {
              ...prematricula.amigo,
            },
            amigoAlt: prematricula.amigoAlt,
            pagoTPVs: prematricula.pagoTPVs,
          },
          localizacion: {
            ...prematricula.localizacion,
          },
          pagoTPVs: prematricula.pagoTPVs,
          estadio: prematricula.estadio,
        },
      };
    },

    /**
     * Buscador (custom filter)
     *
     * Filtra por:
     *   - id prematricula
     *   - numero pedido
     *   - solicitante:
     *     - Dni
     *     - Nombre y apellidos
     *   - alumno:
     *     - Nombre y apellidos
     *     - Codigo
     */
    customFilter(value, search, item) {
      let inPrematriculaId = RegExp(search, "i").test(item.prematricula.id);
      let numeroPedido = this.obtenerNumeroPedido(item);
      let inNumeroPedido = RegExp(search, "i").test(numeroPedido);
      let inTutorDni = RegExp(search, "i").test(item.tutor.dni);
      let inTutorNombre = RegExp(search, "i").test(item.tutor.nombre);
      let inAlumnoCodigo = RegExp(search, "i").test(item.alumno.codigo);
      let inAlumnoNombre = RegExp(search, "i").test(item.alumno.nombre);

      return (
        inPrematriculaId ||
        inNumeroPedido ||
        inTutorDni ||
        inTutorNombre ||
        inAlumnoCodigo ||
        inAlumnoNombre
      );
    },

    /**
     * Filtro Localizacion
     */
    filtrarLocalizacion(value) {
      if (!this.searchLocalizacion) {
        return true;
      }

      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      return value.toLowerCase() == this.searchLocalizacion.toLowerCase();
    },

    /**
     * Filtro Idioma
     */
    filtrarIdioma(value) {
      // no se ha seleccionado idioma se retornan todos
      if (!this.searchIdioma) {
        return true;
      }

      // se ha seleccionado idioma quitamos todos los valores nulos, vacios y no definidos
      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      // retornamos coincidencias
      return value.toLowerCase() == this.searchIdioma.toLowerCase();
    },

    /**
     * Filtro Nivel
     */
    filtrarNivel(value) {
      if (!this.searchNivel) {
        return true;
      }

      if (typeof value == "undefined" || value == null || value == "") {
        return false;
      }

      return value.toLowerCase() == this.searchNivel.toLowerCase();
    },

    /**
     * Resetear los filtros seleccionados
     */
    borrarFiltros() {
      this.search = "";
      this.searchLocalizacion = "";
      this.searchIdioma = "";
      this.searchNivel = "";
      this.niveles = [];

      if (!this.locationFilterAllowedRoles.includes(this.userRoles[0])) {
        this.searchLocalizacion =
          this.userRoles[0].split("ROLE_SUPER_ADMIN_")[1].substring(0, 1) +
          this.userRoles[0]
            .split("ROLE_SUPER_ADMIN_")[1]
            .substring(1)
            .toLowerCase();

        this.cargarIdiomas();
      }
    },

    cargarIdiomas() {
      this.idiomas = [];
      this.searchIdioma = "";

      if (
        !this.searchLocalizacion ||
        typeof this.searchLocalizacion === "undefined"
      ) {
        return;
      }

      let localizacionSeleccionada = this.localizaciones.find(
        (localizacion) =>
          localizacion.nombre.toLowerCase() ==
          this.searchLocalizacion.toLowerCase()
      );
      if (typeof localizacionSeleccionada === "undefined") {
        return;
      }

      this.idiomas = localizacionSeleccionada.idiomas.map(
        (idioma) => idioma.idioma
      );

      return;
    },

    /**
     * valores desponibles en el filtro de nivel teniendo en cuenta el idioma
     */
    cargarNiveles() {
      this.niveles = [];
      this.searchNivel = "";

      if (!this.searchIdioma || typeof this.searchIdioma === "undefined") {
        return;
      }

      let idiomaSeleccionado = this.idiomas.find(
        (idioma) =>
          idioma.nombre.toLowerCase() == this.searchIdioma.toLowerCase()
      );
      if (typeof idiomaSeleccionado === "undefined") {
        return;
      }

      let localizacionSeleccionada = this.localizaciones.find(
        (localizacion) =>
          localizacion.nombre.toLowerCase() ==
          this.searchLocalizacion.toLowerCase()
      );

      this.niveles = localizacionSeleccionada.niveles.filter(
        (nivel) => nivel.idioma.id == idiomaSeleccionado.id
      );

      return;
    },

    /**
     * determina si se carga o no la columna de acciones
     */
    allowShowActions() {
      return this.actions.allowEditPrematricula;
    },

    /**
     * Metodos para la edicion de la columna nivel
     */
    save(item) {
      // comprobar que tenemos identificado el elmento a guardar
      if (this.nivelEditedIndex > -1 && this.nivelTemp != null) {
        // se ha actualizado guardamos ...
        if (
          typeof this.nivelTemp.id != "undefined" ||
          this.nivelEditedItem.nivel.id != this.nivelTemp.id
        ) {
          // api post prematriculaAlumno con el nuevo nivel
          item.nivel = Object.assign({}, this.nivelTemp);

          updatePrematriculaNivel(item).then((response) => {
            if (response.status == 200) {
              this.items[this.nivelEditedIndex].nivel = Object.assign(
                {},
                response.data.nivel
              );
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "successColor"),
                text: this.$getStringFor("snack", "successText"),
              });
            } else {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "errorColor"),
                text: this.$getStringFor("snack", "errorText"),
              });
            }
            this.resetNivelEditedValues();
          });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
        this.resetNivelEditedValues();
      }
    },

    saveTemp(value) {
      this.nivelTemp = Object.assign({}, value);
    },

    cancel() {
      this.setSnack({
        active: true,
        timeout: 1500,
        color: this.$getStringFor("snack", "cancelColor"),
        text: this.$getStringFor("snack", "cancelText"),
      });

      this.resetNivelEditedValues();
    },

    open(item) {
      this.nivelEditedIndex = this.items.indexOf(item);
      this.nivelEditedItem = Object.assign({}, item);
    },

    close() {
      // hacer algo ...
    },

    resetNivelEditedValues() {
      this.nivelEditedIndex = -1;
      this.nivelEditedItem = null;
      this.nivelTemp = null;
    },

    /**
     * Exportar datos de la tabla a csv
     */
    exportItems() {
      // Obtener los items actuales de la tabla (total, no solo los de la pagina actual)
      // hasta que no se ofrezca una solucion oficial hay que referenciar la
      // tabla y obtener de la referencia los items filtrados.
      let filteredItems = this.$refs.dataTable.$children[0].filteredItems;

      // ordenar los valores si es necesario
      if (!_.isNil(this.sortBy) && !_.isEmpty(this.sortBy)) {
        // check if array sortBy & sortDesc
        if (_.isArray(this.sortBy)) {
          this.sortBy = [...this.sortBy].shift();
        }

        if (_.isArray(this.sortDesc)) {
          this.sortDesc = [...this.sortDesc].shift();
        }

        let propertiesArray = [];
        let multipleProperty = RegExp(".", "i").test(this.sortBy);
        if (!_.isNil(multipleProperty)) {
          propertiesArray = this.sortBy.split(".");
        }

        // ordenar los valores.
        filteredItems = filteredItems.sort((a, b) => {
          let aValue = a[propertiesArray[0]][propertiesArray[1]];
          let bValue = b[propertiesArray[0]][propertiesArray[1]];

          if (_.isNil(aValue)) {
            return !this.sortDesc ? -1 : 1;
          }

          if (_.isNil(bValue)) {
            return !this.sortDesc ? 1 : -1;
          }

          // Si es una cadena pasamos a minusculas
          aValue = _.isString(aValue) ? _.toLower(aValue) : aValue;
          bValue = _.isString(bValue) ? _.toLower(bValue) : bValue;

          if (_.isString(aValue) && _.isString(bValue)) {
            let compare = aValue.localeCompare(bValue, undefined, {
              sensitivity: "base",
            });

            if (compare === 1) {
              return !this.sortDesc ? 1 : -1;
            }

            if (compare === -1) {
              return !this.sortDesc ? -1 : 1;
            }

            return 0;
          } else {
            if (aValue < bValue) {
              return !this.sortDesc ? -1 : 1;
            }

            if (aValue > bValue) {
              return !this.sortDesc ? 1 : -1;
            }

            // son iguales
            return 0;
          }
        });
      }

      // configuracion csv
      let csvHeaders = [
        "Localización",

        // datos del solicitante (Tutor)
        "Tutor Dni",
        "Tutor Apellidos, Nombre",
        "Tutor Email",
        "Tutor Teléfono",
        "Tutor Código Postal",

        // datos varios
        "¿Cómo nos has conocido?",
        "Código amigo",
        "Código amigo Alt",
        "Colegio",
        "Empresa",
        "Nº abonado Fundacion Estadio",

        // fase
        "Fase de prematriculación",

        // datos del alumno
        "Alumno Apellidos, Nombre",
        "Alumno Código",
        "Alumno Dni",
        "Alumno Teléfono",
        "Alumno Fecha de Nacimiento",

        // idioma y nivel
        "Idioma",
        "Nivel",
      ];

      let csvValues = {
        localizacion: ["nombre"],
        tutor: ["dni", "nombre", "email", "telefono", "codigoPostal"],
        formaConocer: ["forma"],
        amigo: ["id"],
        prematricula: ["amigoAlt", "colegio", "empresa", "estadio", "fase"],
        alumno: ["nombre", "codigo", "dni", "telefono", "fechaNacimiento"],
        idioma: ["nombre"],
        nivel: ["descripcion"],
      };

      // generar contenido csv
      var universalBOM = "\ufeff";
      let csvContent = "data:text/csv;charset=utf-8," + universalBOM;
      csvContent += [
        Object.values(csvHeaders).join(";"),
        ...filteredItems.map((item) => {
          let values = [];
          let dateUtils = null;

          Object.keys(csvValues).map((objKey) => {
            // cada key de los objetos en csvValues (tutor, alumno ...)
            csvValues[objKey].map((property) => {
              if (objKey == "localizacion" && property == "nombre") {
                values.push(item["prematricula"][objKey][property]);
              } else if (objKey == "formaConocer" && property == "forma") {
                values.push(item["prematricula"][objKey][property]);
              } else if (objKey == "amigo" && property == "id") {
                values.push(item["prematricula"][objKey][property]);
              } else if (property == "fechaNacimiento") {
                dateUtils = new DateUtils(item[objKey][property]);
                values.push(dateUtils.formatDateDDMMYYYY());
              } else {
                values.push(item[objKey][property]);
              }
            });
          });
          return values.join(";");
        }),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      // codificar el contenido del csv y crear elemento link y simular descarga.
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", `prematriculas.csv`);
      link.click();
    },

    exportMatriculasItems() {
      let csvHeaders = [
        // datos del solicitante (Tutor)
        "Tutor Dni",
        "Tutor Apellidos, Nombre",
        "Tutor Email",
        "Tutor Teléfono",
        "Tutor Código Postal",

        // datos varios
        "¿Cómo nos has conocido?",
        "Código amigo",
        "Código amigo Alt",
        "Colegio",
        "Empresa",
        "Nº abonado Fundacion Estadio",

        // datos del alumno
        "Alumno Apellidos, Nombre",
        "Alumno Código",
        "Alumno Dni",
        "Alumno Teléfono",
        "Alumno Fecha de Nacimiento",

        // idioma y nivel
        "Idioma",
        "Nivel",
      ];

      let universalBOM = "\ufeff";

      let csvContent = "data:text/csv;charset=utf-8," + universalBOM;
      csvContent += [
        Object.values(csvHeaders).join(";"),
        ...this.matriculas.map((item) => {
          if (item.fechaNacimiento.date) {
            let dateUtils = new DateUtils(
              item.fechaNacimiento.date.replace(" ", "T")
            );
            item.fechaNacimiento = dateUtils.formatDateDDMMYYYY();
          }

          return Object.values(item).join(";");
        }),
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "matriculas.csv");
      link.click();
    },

    /**
     * Cierra el dialog y reinicia los valores del tab activo y
     * el item cargado anteriormente
     */
    closeDialogPrematricula() {
      this.dialogPrematricula = false;
      this.changeTab(0);
      this.editedItem = null;
      this.prematriculaAlumnosIdiomas = null;
    },

    /**
     * Abre el dialog y setea el item a cargar en los tabs
     */
    editItem(item) {
      // setear el item seleccionado para la edicion
      this.editedItem = item;

      // Generar array con los datos de todos los alumnos-idiomas correspondientes a la prematricula del item seleccionado
      this.prematriculaAlumnosIdiomas = this.items.reduce((acc, tableItem) => {
        if (tableItem.prematricula.id === this.editedItem.prematricula.id) {
          acc.push({
            id: tableItem.id,
            alumno: tableItem.alumno,
            idioma: tableItem.idioma,
            nivel: tableItem.nivel,
          });
        }
        return acc;
      }, []);

      // abrir dialog
      this.dialogPrematricula = true;
    },

    /**
     * Determina en que item del listado se ha clicado y hay que cargar el loading o deshabilitar el boton
     */
    isCurrentMatriculaItemLoading(item) {
      return this.loadingMatriculaActionRef == `btn-matricula-${item.id}`;
    },

    /**
     * Dialog para realizar/editar/ver la matricula
     */
    async matriculaItem(item) {
      this.loadingActionMatricula = true;
      this.loadingMatriculaActionRef = `btn-matricula-${item.id}`;
      this.isMatriculaNew = true;

      //objeto matricula
      await this.initializeEditedMatricula().then((matriculaItem) => {
        this.editedMatricula = matriculaItem;
      });

      // obtener la prematricula a partir del item seleccionado
      await getById(item.prematricula.id)
        .then((response) => (this.editedMatricula.prematricula = response.data))
        .catch((error) => console.error(error));

      // curso relacionado a la prematricula
      const curso = this.editedMatricula.prematricula.curso;
      const localizacion = this.editedMatricula.prematricula.localizacion;

      // grupos disponibles del curso
      await getGrupos(curso.id, localizacion.id)
        .then((response) => (this.editedMatricula.grupos = response.data))
        .catch((error) => console.error(error));

      // tipos de pago
      await getTiposPago()
        .then((response) => {
          this.editedMatricula.paymentOptions = this.parseTiposPago(
            response.data
          );
        })
        .catch((error) => console.error(error));

      // metodo de pago
      await getMetodosPago()
        .then((response) => {
          this.editedMatricula.paymentMethods = this.parseMetodosPago(
            response.data
          );
        })
        .catch((error) => console.error(error));

      // prematriculasAlumnos agrupado por alumno
      const matriculaUtils = new MatriculaUtils();
      this.editedMatricula.alumnos = await matriculaUtils.agruparAlumnos(
        this.editedMatricula.prematricula
      );

      // obtener las matriculas asociadas a la prematricula
      await getByPrematricula(this.editedMatricula.prematricula.id)
        .then((response) => (this.editedMatricula.matriculas = response.data))
        .catch((error) => console.error(error));

      // si tiene matriculas creadas con anterioridad se sobrescriben los grupos de estas
      if (this.editedMatricula.matriculas.length) {
        this.isMatriculaNew = false;
        await this.overrideEditedMatriculaWithExistingData().catch((error) =>
          console.error(error)
        );
      }

      // abrir dialog
      this.loadingMatriculaActionRef = "";
      this.loadingActionMatricula = false;
      this.dialogMatricula = true;
    },

    initializeEditedMatricula() {
      return new Promise((resolve, reject) => {
        try {
          let itemMatricula = {
            prematricula: null,
            alumnos: [],
            grupos: null,
            grupos_seleccionados: [],
            matriculas: [],
            metodosPago: [],
            gratuita: "no",
            paymentOption: "1",
            paymentMethod: null,
            iban_pais_dc: "",
            iban_pais_codigo: "",
            iban_entidad: "",
            iban_sucursal: "",
            iban_dc: "",
            iban_cuenta: "",
            paymentOptions: null,
            paymentMethods: null,
            gratuitaOptions: [
              { text: "Sí", value: "si" },
              { text: "No", value: "no" },
            ],
            total: 0,
          };

          resolve(itemMatricula);
        } catch (error) {
          reject(error);
        }
      });
    },

    overrideEditedMatriculaWithExistingData() {
      return new Promise((resolve, reject) => {
        try {
          const { prematricula } = this.editedMatricula;

          /**
           * campos de la prematricula
           */
          // gratuita
          this.editedMatricula.gratuita = prematricula.gratuita ? "si" : "no";

          //tipo de pago
          if (!_.isNil(prematricula.pagoTipo)) {
            this.editedMatricula.paymentOption = String(
              prematricula.pagoTipo.id
            );
          }

          // metodo de pago
          if (!_.isNil(prematricula.pagoMetodo)) {
            this.editedMatricula.paymentMethod = String(
              prematricula.pagoMetodo.id
            );

            if (prematricula.pagoMetodo.id == 2) {
              if (!_.isNil(prematricula.cuenta)) {
                // le damos la vuelta para empezar por los 20 digitos, ya que los antiguos registros
                // lo tienen asi, los nuevos incluyen el codigo de pais y el codigo de control del pais. (4+)
                let strCuenta = this.reverseString(prematricula.cuenta);

                let entidad = strCuenta.slice(16, 20);
                let sucursal = strCuenta.slice(12, 16);
                let dc = strCuenta.slice(10, 12);
                let cuenta = strCuenta.slice(0, 10);

                // iban
                this.editedMatricula.iban_entidad = this.reverseString(entidad);
                this.editedMatricula.iban_sucursal = this.reverseString(
                  sucursal
                );
                this.editedMatricula.iban_dc = this.reverseString(dc);
                this.editedMatricula.iban_cuenta = this.reverseString(cuenta);
              }
            }
          }

          /**
           * campos de las matriculas
           */
          this.editedMatricula.matriculas.forEach((matricula) => {
            // override groups
            this.editedMatricula.alumnos.forEach((alumno) => {
              if (alumno.id !== matricula.alumno.id) {
                return;
              }

              let prematricula = alumno.prematriculas.find((prematricula) => {
                return prematricula.nivel.id === matricula.nivel.id;
              });

              if (prematricula) {
                prematricula.grupo = this.parseItemGrupo(matricula.grupo);
              }
            });
          });

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    reverseString(str) {
      if (!str.length) {
        return "";
      }

      return [...str].reverse().join("");
    },

    calculateEditedMatriculaTotal() {
      if (this.editedMatricula.gratuita == "si") {
        this.editedMatricula.total = 0;
        return "Gratuita";
      }

      let total = 0;
      this.editedMatricula.alumnos.forEach((alumno) => {
        alumno.prematriculas.forEach((prematricula) => {
          if (prematricula.grupo != null) {
            if (this.editedMatricula.paymentOption == 1) {
              total += parseFloat(prematricula.grupo.value.precio);
            } else {
              total += parseFloat(prematricula.grupo.value.precioIncrementado);
            }
          }
        });
      });

      this.editedMatricula.total = total;

      return total;
    },

    /**
     * Cierra el dialog de matricula
     */
    closeDialogMatricula() {
      this.dialogMatricula = false;
      this.editedMatricula = null;
    },

    /**
     * Obtiene las opciones disponibles de grupo para
     * el formulario de matricula dependiendo el nivel de la prematriculaAlumno
     */
    generarItemsGrupo(idNivel) {
      let items = [];
      let grupos = this.obtenerGruposPorNivel(idNivel);

      grupos.forEach((g) => {
        items.push(this.parseItemGrupo(g));
      });

      return items;
    },

    parseItemGrupo(grupo) {
      let infoPlazas = this.infoPlazas(grupo.plazasDisponibles);
      let text = `${grupo.dia.descripcion} - ${grupo.horario.descripcion}`;

      if (!_.isNil(grupo.aula)) {
        text = text + ` - ${grupo.aula.numero}`;
      }

      text = text + ` (${infoPlazas})`;

      let item = {
        value: { ...grupo },
        text,
      };

      return item;
    },

    obtenerGruposPorNivel(idNivel) {
      return this.editedMatricula.grupos.filter(
        (grupo) => grupo.nivel.id == idNivel
      );
    },

    infoPlazas(plazasDiponibles) {
      if (plazasDiponibles == 0 || plazasDiponibles == null) {
        return "Completo";
      }

      return plazasDiponibles;
    },

    changeGratuita(value) {
      if (value == "si") {
        this.editedMatricula.paymentMethod = null;
      }
    },

    changePaymentOption(value) {
      if ("2" == value) {
        this.editedMatricula.paymentMethod = "2";
      }
    },

    isPaymentFraccionado(currentValue) {
      if (2 == currentValue) {
        return false;
      }

      if (2 == this.editedMatricula.paymentOption) {
        return true;
      }
    },

    changeGrupo() {
      // do something
    },

    clearGrupo() {
      // do something
    },

    parseTiposPago(tipos) {
      let parsed = [];

      tipos.forEach((tipo) => {
        parsed.push({ value: String(tipo.id), text: tipo.nombre });
      });

      return parsed;
    },

    parseMetodosPago(metodos) {
      let parsed = [];

      metodos.forEach((metodo) => {
        parsed.push({ value: String(metodo.id), text: metodo.nombre });
      });

      return parsed;
    },

    onSubmitMatricula() {
      this.loadingSubmitMatriculas = true;

      const params = this.generateMatriculaRequestParams();

      matricular(params)
        .then((response) => {
          const status = response.status;
          const data = response.data;

          if (status == 200 && _.isEmpty(data.ko)) {
            this.setSnack({
              active: true,
              timeout: 1500,
              color: this.$getStringFor("snack", "successColor"),
              text: this.$getStringFor("snack", "successText"),
            });
          } else {
            this.setSnack({
              active: true,
              timeout: 1500,
              color: this.$getStringFor("snack", "errorColor"),
              text: this.$getStringFor("snack", "errorText"),
            });
          }
        })
        .catch((error) => {
          let message = this.$getStringFor("snack", "errorText");
          let timeout = 1500;

          if (error.response.status == 409) {
            message = error.response.data.detail;
            timeout = 3000;
          }

          this.setSnack({
            active: true,
            timeout,
            color: this.$getStringFor("snack", "errorColor"),
            text: message,
          });
        });

      this.loadingSubmitMatriculas = false;
    },

    generateMatriculaRequestParams() {
      const {
        prematricula,
        alumnos,
        gratuita,
        total: importe,
        paymentMethod: pagoMetodo,
        paymentOption: pagoTipo,
        iban_pais_codigo: pais,
        iban_pais_dc: paisDC,
        iban_entidad: entidad,
        iban_sucursal: sucursal,
        iban_dc: dc,
        iban_cuenta: cuenta,
      } = this.editedMatricula;

      // array de matriculas x alumno
      let matriculasAll = [];
      let matriculas;
      for (var { id: alumno, prematriculas: matriculasAlumno } of alumnos) {
        matriculas = [];
        for (var { grupo } of matriculasAlumno) {
          if (grupo != null) {
            matriculas.push({ grupo: grupo.value.id });
          }
        }
        matriculasAll.push({ alumno, matriculas });
      }

      return {
        prematricula: prematricula.id,
        pagoMetodo: gratuita == "si" ? null : pagoMetodo,
        pagoTipo: gratuita == "si" ? null : pagoTipo,
        iban: {
          pais,
          paisDC,
          entidad,
          sucursal,
          dc,
          cuenta,
        },
        matriculas: matriculasAll,
        importe,
        gratuita: gratuita == "si" ? true : false,
      };
    },

    togglePaymentsOptions() {
      return (
        this.editedMatricula != null && this.editedMatricula.gratuita == "no"
      );
    },

    /**
     * prematricula actualizada desde tab de prematricula
     */
    updatePrematricula(event, response) {
      if (response.status == 200) {
        let item = response.data;
        // Buscar los indices de los items de la tabla que tengan asociado la prematricula
        // modificada para actualizarlas
        let filtered = this.items.reduce((acc, tableItem, index) => {
          if (tableItem.prematricula.id === item.id) {
            acc.push(index);
          }

          return acc;
        }, []);

        // actualizar los registros de la tabla
        filtered.map((index) => {
          this.items[index].prematricula = Object.assign(
            {},
            {
              id: item.id,
              codigo: item.codigo,
              entidad: item.entidad,
              oficina: item.oficina,
              cuenta: item.cuenta,
              anulada: item.anulada,
              domiciliacion: item.domiciliacion,
              orden: item.orden,
              gratuita: item.gratuita,
              colegio: item.colegio,
              empresa: item.empresa,
              veracidad: item.veracidad,
              privacidad: item.privacidad,
              fase: item.fase,
              formaConocer: item.formaConocer,
              amigo: item.amigo,
              amigoAlt: item.amigoAlt,
              estadio: item.estadio,
              localizacion: item.localizacion,
            }
          );
        });

        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.$getStringFor("snack", "successText"),
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },

    /**
     * solicitante actualizado desde tab de solicitante
     */
    updateSolicitante(event, response) {
      if (response.status == 200) {
        let item = response.data;
        // Buscar los indices de los items de la tabla que tengan asociado el solicitante
        // modificado para actualizarlas
        let filtered = this.items.reduce((acc, tableItem, index) => {
          if (
            tableItem.tutor.id === item.persona.id ||
            tableItem.alumno.id === item.persona.id
          ) {
            acc.push(index);
          }

          return acc;
        }, []);

        // actualizar los registros de la tabla
        filtered.map((index) => {
          // comprobar si la coincidencia es en el tutor
          if (this.items[index].tutor.id === item.persona.id) {
            this.items[index].tutor = Object.assign({}, item.persona);
          }

          // comprobar si la coincidencia es en el alumno
          if (this.items[index].alumno.id === item.persona.id) {
            this.items[index].alumno = Object.assign({}, item.persona);
          }
        });

        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.$getStringFor("snack", "successText"),
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },

    /**
     * Envío de emails de la prematricula al correo del solicitante desde el tab de solicitante
     */
    sendEmails(event, response) {
      if (response.status == 200) {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.snackSuccessTextSendEmails,
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.snackErrorTextSendEmails,
        });
      }
    },

    updateAlumno(event, response, editedItemAlumno) {
      if (response.status == 200) {
        // Buscar los indices de los items de la tabla que tengan asociado el solicitante
        // modificado para actualizarlas
        let filtered = this.items.reduce((acc, tableItem, index) => {
          if (
            tableItem.tutor.id === editedItemAlumno.id ||
            tableItem.alumno.id === editedItemAlumno.id
          ) {
            acc.push(index);
          }

          return acc;
        }, []);

        // actualizar los registros de la tabla
        filtered.map((index) => {
          // comprobar si la coincidencia es en el tutor
          if (this.items[index].tutor.id === editedItemAlumno.id) {
            this.items[index].tutor = Object.assign({}, editedItemAlumno);
          }

          // comprobar si la coincidencia es en el alumno
          if (this.items[index].alumno.id === editedItemAlumno.id) {
            this.items[index].alumno = Object.assign({}, editedItemAlumno);
          }
        });

        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.$getStringFor("snack", "successText"),
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },

    async updateAlumnoIdiomas(event, response) {
      if (response.status == 200) {
        // si la prematricula que se ha actualizado se queda sin alumnos se borra definitivamente.
        if (
          response.data.alumnos == null ||
          response.data.alumnos.length == 0
        ) {
          // eliminar prematricula
          await remove(response.data)
            .then((response) => {
              if (
                response.status == 204 &&
                response.statusText == "No Content"
              ) {
                // actualiza listado de la tabla.
                this.refreshItems();

                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "successColor"),
                  text: this.snackSuccessTextRemove,
                });

                // cerrar full screen
                this.closeDialogPrematricula();
              } else {
                // actualiza listado de la tabla.
                this.refreshItems();

                this.setSnack({
                  active: true,
                  timeout: 1500,
                  color: this.$getStringFor("snack", "errorColor"),
                  text: this.snackErrorTextRemove,
                });
              }
            })
            .catch((error) => {
              console.error(error);
            });
        } else {
          //actualizar el array de idiomas
          this.prematriculaAlumnosIdiomas = Object.assign(
            [],
            response.data.alumnos
          );

          // actualiza listado de la tabla.
          this.refreshItems();

          this.setSnack({
            active: true,
            timeout: 1500,
            color: this.$getStringFor("snack", "successColor"),
            text: this.$getStringFor("snack", "successText"),
          });
        }
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },

    addAlumno(event, response) {
      if (response.status == 200) {
        // array de alumnos actual
        let oldPrematriculaAlumnos = this.prematriculaAlumnosIdiomas;

        // actualizar array de alumnos con la respuesta
        //this.prematriculaAlumnosIdiomas = response.data.alumnos
        //let newPrematriculaAlumnos = Object.assign([], this.prematriculaAlumnosIdiomas)

        // Cargar al nuevo alumno como item a editar
        this.loadAddedAlumno(response.data, oldPrematriculaAlumnos); //, newPrematriculaAlumnos)

        // actualiza listado de la tabla.
        this.refreshItems();

        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "successColor"),
          text: this.$getStringFor("snack", "successText"),
        });
      } else {
        this.setSnack({
          active: true,
          timeout: 1500,
          color: this.$getStringFor("snack", "errorColor"),
          text: this.$getStringFor("snack", "errorText"),
        });
      }
    },

    changeTab(tabIndex) {
      this.tab = tabIndex;
    },

    /**
     * Obtiene el item añadido, lo carga como item para el dialog y actualiza el array de alumnos.
     *
     * prematricula: objeto prematricula
     * oldPrematriculaAlumnos: array de alumnos de la prematricula, antes de añadir el nuevo
     * newPrematriculaAlumnos: array de alumnos de la prematricula, actualizado con el nuevo alumno
     */
    loadAddedAlumno(prematricula, oldPrematriculaAlumnos) {
      //}, newPrematriculaAlumnos) {
      // nuevo array de alumnos
      this.prematriculaAlumnosIdiomas = prematricula.alumnos;
      let newPrematriculaAlumnos = Object.assign(
        [],
        this.prematriculaAlumnosIdiomas
      );

      // obtener el alumno añadido
      let addedPrematriculaAlumnoArr = newPrematriculaAlumnos.filter(
        (item) => !oldPrematriculaAlumnos.some((other) => item.id === other.id)
      );

      // generar el item
      let addedItem = this.generateItem(
        prematricula,
        addedPrematriculaAlumnoArr[0]
      );

      // setear el item seleccionado para la edicion
      this.editedItem = Object.assign({}, addedItem);

      // obligar a recargar los componentes de editDialog
      this.forceRerenderEditDialogComponents();

      // activar tab de Inf. alumno
      this.tab = 2;
    },

    forceRerenderEditDialogComponents() {
      this.editDialogComponentsKey += 1;
    },

    async asignarNivelesPorTipo(tipo, title, subtitle, message, message2) {
      // confirmacion
      if (
        await this.$refs.confirmNiveles.open(
          title,
          subtitle,
          message,
          message2,
          {
            color: "primary",
            width: 300,
          }
        )
      ) {
        // Si acepta asignamos los valores
        await asignarNivelesAlumnos(tipo)
          .then(() => {
            true;
          })
          .catch((error) => {
            console.error(error);
            return false;
          });
      } else {
        return false;
      }
    },

    async asignarNivelesNuevosAlumnos() {
      this.loadingAsignarNivelesNuevosAlumnos = true;

      let title = "Asignar niveles";
      let subtitle = "Alumnos NUEVOS";
      let message =
        "Usted va a asignar niveles a los alumnos NUEVOS que no tengan todavía nivel asignado.";
      let message2 = "¿Está seguro?";

      await this.asignarNivelesPorTipo(
        "nuevos",
        title,
        subtitle,
        message,
        message2
      ).then(() => {
        this.loadingAsignarNivelesNuevosAlumnos = false;
        this.refreshItems();
      });
    },

    async asignarNivelesAntiguosAlumnos() {
      this.loadingAsignarNivelesAntiguosAlumnos = true;

      let title = "Asignar niveles";
      let subtitle = "Alumnos ANTIGUOS";
      let message =
        "Usted va a asignar niveles a los alumnos ANTIGUOS que no tengan todavía nivel asignado.";
      let message2 = "¿Está seguro?";

      await this.asignarNivelesPorTipo(
        "antiguos",
        title,
        subtitle,
        message,
        message2
      ).then(() => {
        this.loadingAsignarNivelesAntiguosAlumnos = false;
        this.refreshItems();
      });
    },

    /**
     * Determina si mostrar o no los botones para asignar niveles
     *
     * Mostrar solo, si el año actual es igual al año del curso seleccionado en el combo de cursos (cursoActual)
     */
    isShowAsignarNivelesAlumnos() {
      if (this.cursoActual == null) {
        return false;
      }

      let fechaActual = new Date();
      let anioActual = fechaActual.getFullYear();
      let anioCursoActual = parseInt(this.cursoActual.anio);

      return anioCursoActual == anioActual;
    },
  },
};
</script>
